import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ThemeProvider } from "./context/theme";
import { LocaleProvider } from "./context/locale";
import Metadata from "./comps/web/nav/metadata";
import Layout from "./comps/web/nav/layout";

import Home from "./comps/web/main/home";
import TrustedEcosystem from "./comps/web/main/trusted-ecosystem/trustedEcosystem";
import Solutions from "./comps/web/main/solutions/solutions";
import ItrustComingSoon from "./comps/web/main/solutions/itrustComingSoon";
import Markets from "./comps/web/main/markets/markets";
import MarketGlobal from "./comps/web/main/markets/global";
import MarketIndia from "./comps/web/main/markets/india";
import MarketUSA from "./comps/web/main/markets/usa";
import Invest from "./comps/web/main/invest/invest";
import Careers from "./comps/web/main/careers/careers";
import Contact from "./comps/web/main/contact";
import DataSovereignty from "./comps/web/main/legal/dataSovereignty";
import Privacy from "./comps/web/main/legal/privacy";
import Terms from "./comps/web/main/legal/terms";
import NoPage from "./comps/web/main/nopage";

// DeviceWorks — separate sub-brand: secondary nav + own footer,
// but nested under the parent Layout so the global header persists.
import DWSection from "./comps/deviceworks/dwLayout";
import DWHome from "./comps/deviceworks/pages/home";
import DWMarketplace from "./comps/deviceworks/pages/marketplace";
import DWMarketplaceCompare from "./comps/deviceworks/pages/marketplaceCompare";
import DWLifecycleServices from "./comps/deviceworks/pages/lifecycleServices";
import DWHowWeWork from "./comps/deviceworks/pages/howWeWork";
import DWInsights from "./comps/deviceworks/pages/insights";
import DWInsightPost from "./comps/deviceworks/pages/insightPost";
import DWIndustries from "./comps/deviceworks/pages/industries";
import DWOemPartners from "./comps/deviceworks/pages/oemPartners";
import DWLogisticsPartners from "./comps/deviceworks/pages/logisticsPartners";
import DWGetAQuote from "./comps/deviceworks/pages/getAQuote";
import DWContact from "./comps/deviceworks/pages/contact";
import DWAbout from "./comps/deviceworks/pages/about";
import DWLocations from "./comps/deviceworks/pages/locations";
import DWLogin from "./comps/deviceworks/pages/login";

function App() {
  return (
    <ThemeProvider>
      <LocaleProvider>
      <Metadata
        title="Tapaswe Trusted Ecosystem"
        description="Tapaswe Global — building Trusted Ecosystems in every community we operate in."
        keywords="tapaswe global trusted ecosystem itrust deviceworks india usa"
      />
      <BrowserRouter>
        <Routes>
          {/* Parent site — Tapaswe Global chrome (global nav persists everywhere below) */}
          <Route element={<Layout />}>
            <Route index path="/" element={<Home />} />
            <Route path="/trusted-ecosystem" element={<TrustedEcosystem />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/itrust-id" element={<ItrustComingSoon />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/markets/global" element={<MarketGlobal />} />
            <Route path="/markets/india" element={<MarketIndia />} />
            <Route path="/markets/usa" element={<MarketUSA />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/data-sovereignty" element={<DataSovereignty />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* DeviceWorks — own secondary nav + footer, docked under the global header */}
            <Route path="/solutions/deviceworks" element={<DWSection />}>
              <Route index element={<DWHome />} />
              <Route path="marketplace" element={<DWMarketplace />} />
              <Route path="marketplace/compare" element={<DWMarketplaceCompare />} />
              <Route path="lifecycle-services" element={<DWLifecycleServices />} />
              <Route path="how-we-work" element={<DWHowWeWork />} />
              <Route path="insights" element={<DWInsights />} />
              <Route path="insights/:slug" element={<DWInsightPost />} />
              <Route path="industries" element={<DWIndustries />} />
              <Route path="oem-partners" element={<DWOemPartners />} />
              <Route path="logistics-partners" element={<DWLogisticsPartners />} />
              <Route path="get-a-quote" element={<DWGetAQuote />} />
              <Route path="contact" element={<DWContact />} />
              <Route path="about" element={<DWAbout />} />
              <Route path="locations" element={<DWLocations />} />
              <Route path="login" element={<DWLogin />} />
            </Route>

            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </LocaleProvider>
    </ThemeProvider>
  );
}

export default App;
